import { AmityAuthProvider } from "@/providers";

import { ProfileUpdateScreen } from "@/app/modules/User/ProfileUpdateScreen.tsx";

export const ProfileUpdate = () => (
  <AmityAuthProvider>
    <ProfileUpdateScreen />
  </AmityAuthProvider>
);
